// extracted by mini-css-extract-plugin
export default {"loader":"globalLoading_loader__d+mwl"};